<template>
    <div class="d-flex flex-column flex-grow-1 flex-shrink-0">
        <div class="d-flex flex-row">
            <span class="font-italic d-flex flex-grow-1 flex-shrink-0">
                <b v-if="instrument.name!=''">{{ instrument.name }} / </b><b>{{ instrument.serno}}</b> - <b>{{ instrument.manufacturer}}</b> - <b>{{ instrument.model }}</b> </span>
            <i class="d-flex flex-grow-0 flex-shrink-1">{{ instrument.family }}</i>
        </div>
        <div class="d-flex flex-grow-1 flex-shrink-0">
            <div class="d-flex flex-column flex-grow-1 flex-shrink-0">
                <div v-if="!!client"><b>{{ client.name }}</b> - PIVA: {{ client.piva }}</div>
                <div v-if="!!location">
                    {{ location.name }} - {{ location.address}} {{ location.addrNum }}, {{ location.city }} ({{ location.district }})<br/>
                    <span v-if="instrument.department_id && location.departments[instrument.department_id]">{{ location.departments[instrument.department_id].name }}</span></div>
                <slot name="other_info"></slot>
            </div>
            <div class="d-flex flex-column flex-grow-0 flex-shrink-1" v-if="show_platform_capacity">
                <span v-for="platform in instrument.platforms" :key="platform.id">
                <InstrumentPlatformInfo class="text-right ml-2"
                    v-bind:o_data="platform"/>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
// import _ from 'lodash'

import InstrumentPlatformInfo from './Instrument_utils/Instrument_platform_info'

export default {
    components: {InstrumentPlatformInfo},
    props: {
        instrument: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: false,
            default: null
        },
        location: {
            type: Object,
            required: false,
            default: null
        },
        show_platform_capacity: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}

</script>